<script lang="ts" setup>
import { computed } from "vue"

type Action = { fn?: () => void; message: string; severity?: string }

type Props = {
    severity?: "warn" | "info" | "error"
    message?: string
    closable?: boolean
    action?: Action
    // Conservé pour compatibilité, non utilisé directement
    position?: string
}

const props = withDefaults(defineProps<Props>(), {
    severity: "info",
    message: undefined,
    closable: false,
    action: undefined,
    position: undefined,
})

const emit = defineEmits(["close", "click:action"])

const getIconBySeverity = computed(() => {
    switch (props.severity) {
        case "warn":
            return "pi pi-exclamation-triangle"
        case "error":
            return "pi pi-exclamation-triangle"
        default:
            return "pi pi-info-circle"
    }
})
</script>

<template>
    <BaseMessage
        class="app-message"
        ref="message"
        :severity="severity"
        :closable="closable"
        :pt="{
            content: '!items-start',
            text: 'w-full',
        }"
        :style="{
            '--p-message-content-gap': '1rem',
        }"
        @close="emit('close')"
    >
        <template #icon>
            <BaseIcon
                class="app-message__icon"
                :icon="getIconBySeverity"
                :color="`--p-message-${severity}-icon-color`"
            />
        </template>
        <div class="app-message__wrapper flex flex-col gap-2">
            <div class="message__title font-bold" v-if="$slots.header">
                <slot name="header"></slot>
            </div>
            <div class="app-message__content">
                <!-- Priorité au slot par défaut, sinon prop message (HTML) -->
                <slot v-if="$slots.default"></slot>
                <p v-else-if="message" v-html="message"></p>
            </div>
            <div v-if="action" class="mt-2">
                <BaseButton
                    size="small"
                    :severity="action?.severity ?? 'primary'"
                    @click="action.fn ? action.fn() : emit('click:action')"
                    :label="action.message"
                />
            </div>
        </div>
    </BaseMessage>
</template>

<style scoped></style>
